export const totalPaidPrice = (vendorOrders) =>
  vendorOrders?.reduce((a, b) => a + parseInt(b.agent_received || 0), 0);


